import AppConstants from 'general/constants/AppConstants';
import { t } from 'i18next';

const InvestorHelper = {
  // filter trang thai dai ly
  filterInvestorTypeOptions: () => {
    return [
      { name: t('all'), value: '' },
      {
        name: t(AppConstants.investorType.individual),
        value: AppConstants.investorType.individual,
      },
      {
        name: t(AppConstants.investorType.organization),
        value: AppConstants.investorType.organization,
      },
    ];
  },

  filterInvestorLevelOptions: () => {
    return [
      { name: t('all'), value: '' },
      {
        name: t('level') + ' 1',
        value: 1,
      },
      {
        name: t('level') + ' 2',
        value: 2,
      },
    ];
  },

  // format mã nhà đầu tư
  formatInvestorCode: (investorId) => {
    const prefix = 'NDT';
    const formattedId = investorId;
    return `${formattedId}`;
  },
};

export default InvestorHelper;
